package com.solevo.dist.util

import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.rgba

/**
 * Created by Ilija Vucetic on 7.10.25..
 * Copyright (c) 2025 Aktiia. All rights reserved.
 */
fun rgbaFromHex(hex: String, alpha: Double): CSSColorValue {
    val c = hex.removePrefix("#")
    val (r, g, b) = when (c.length) {
        3 -> listOf(
            c.substring(0, 1).repeat(2),
            c.substring(1, 2).repeat(2),
            c.substring(2, 3).repeat(2),
        ).map { it.toInt(16) }

        6 -> listOf(
            c.substring(0, 2).toInt(16),
            c.substring(2, 4).toInt(16),
            c.substring(4, 6).toInt(16),
        )

        8 -> listOf(
            c.substring(2, 4).toInt(16),
            c.substring(4, 6).toInt(16),
            c.substring(6, 8).toInt(16),
        )

        else -> listOf(0, 0, 0)
    }
    return rgba(r, g, b, alpha.coerceIn(0.0, 1.0))
}

/* helpers */
fun cssColor(hex: String): CSSColorValue = Color(hex)
fun CSSColorValue.withAlpha(a: Float): CSSColorValue =
    when (this) {
        is Color.RGB -> rgba(this.r, this.g, this.b, a)
        else -> this
    }